import {RenewalOption} from "@irati/types"
import {RenewalPlanPlan} from "@irati-tracking/admin/admin"

export default (selectedQuote: RenewalOption) => {
  if (selectedQuote.termLength === 12) {
    return RenewalPlanPlan.TwelvemonthRenewal
  }
  if (selectedQuote.termLength === 24) {
    return RenewalPlanPlan.TwentyFourMonthRenewal
  }
  return RenewalPlanPlan.ThirtySixMonthRenewal
}
